import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import TabMenu from "../../TabMenu";
import AdminMenu from "../../AdminMenu";
import TabMenuWarehouse from "../../TabMenuWarehouse";
import ButtonLink from "../../../ButtonLink";
import FinanceAdminMenu from "../../FinanceAdminMenu";

const AdminData = [
  {
    id: 1,
    name: "Customer Qr Settlement",
    icon: "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/My_Profile.png",
    backgroundColor: "#AD39BF",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/customer-qr-payment",
  },
  {
    id: 2,
    name: "Customer Payment Status Check",
    icon: "Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif",
    backgroundColor: "#1F78D9",
    tintColor: null,
    navigation: "/customer-payment-status-check",
  },
];

const CustomerPaymentSettlement = () => {
  const navigate = useNavigate();
  const [modalMenuVisible, setModalMenuVisible] = useState(false);

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;

  const renderAdminCardItem = () => {
    return AdminData?.map((item, index) => {
      if (userRole === "BY_RIDER" && item.name === "Store User") {
        return null;
      }
      return (
        <div
          onClick={() => navigate(item.navigation)}
          className="flex flex-1 cursor-pointer"
        >
          <div
            className="p-3 m-2"
            style={{
              backgroundColor: item.backgroundColor,
              borderRadius: 10,
            }}
          >
            <img
              src={item.icon}
              style={{
                height: 25,
                width: 25,
                filter: item.tintColor,
              }}
            />
          </div>
          <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
            <div>
              <p className="text-3xl font-semibold">{item.name}</p>
            </div>
            <div>
              <i
                className="pi pi-angle-right"
                style={{ fontSize: "30px", cursor: "pointer", color: "#000" }}
              ></i>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => {
                    userRole === "BY_ACCOUNTANT"
                      ? navigate("/")
                      : navigate("/Setting");
                  }}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">Setting</p>
            </div>
          </div>

          {userRole !== "BY_WAREHOUSE" && (
            <div className="mx-2 cursor-pointer">
              <img
                src={"Laundy_App_Icons_Gifs/SettingIcons/translate.png"}
                style={{ width: 30 }}
              />
            </div>
          )}

          {userRole !== "BY_WAREHOUSE" && (
            <div
              className="flex justify-content-center align-items-center cursor-pointer"
              onClick={() => setVisible(true)}
            >
              <i
                className="pi pi-bars"
                style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
              ></i>
            </div>
          )}
        </div>
      </div>

      <div className="mx-4 my-3">
        {userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER" ? (
          AdminData?.length ? (
            renderAdminCardItem()
          ) : (
            <p>No admin data available.</p>
          )
        ) : (
          <p>No card data available.</p>
        )}

        <div className="flex justify-content-center">
          <img
            src={"VectorsLaundryApp/4.png"}
            style={{
              // width: 100,
              // height: 50,
              alignSelf: "center",
            }}
          />
        </div>
        {/* <StoreLanguage
          setModalLangVisible={setModalLangVisible}
          modalLangVisible={modalLangVisible}
        /> */}
      </div>
      {userRole === "BY_ADMIN" ||
      userRole === "BY_SUB_ADMIN_USER" ||
      userRole === "BY_FRANCHISE_ADMIN" ? (
        <AdminMenu setVisible={setVisible} visible={visible} />
      ) : userRole === "BY_ACCOUNTANT" ? (
        <FinanceAdminMenu setVisible={setVisible} visible={visible} />
      ) : (
        <>
          <StoreMenu setVisible={setVisible} visible={visible} />
          <ButtonLink />
        </>
      )}
      {userRole === "BY_WAREHOUSE" ? <TabMenuWarehouse /> : <TabMenu />}
    </div>
  );
};

export default CustomerPaymentSettlement;
